import React, { useState, Fragment, useEffect, useCallback } from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import Loader from "react-loaders";
import animetionLogo from "../../../assets/utils/images/animetion_logo.gif";

import { Motion, spring } from "react-motion";
import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
} from "react-simple-maps";

import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardHeader,
  Row,
  Col,
  Button,
} from "reactstrap";
import classnames from "classnames";
import { Tooltip } from "react-tooltip";

// Map
import SdgsMap from "./Modules/SdgsMap";

// import VectorMapsDatasets from "../Journy/Components/VectorMaps/Datasets";
import GraphCards from "./Modules/GraphCards";
import InfoTable from "../../Tables/InfoTable";

import { useQuery } from "@apollo/client";
import { GET_JOURNY_INFO } from "../../../../src/queries";
import InterestQuestionnaire from "../../InterestQuetionnaire";
import ActiveCountry from "./Modules/ActiveCountry";
import { sendGAEvent } from "../../../utils";

const JournyDashboard = () => {
  ////* タブ切り替え  *////
  const [activeTab, setActiveTab] = useState("0");

  // refetch用の変数
  const [sdgs_pk, setSdgsPk] = useState([
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
  ]);
  const [act_pk, setActPk] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
  const [nodeId, setNodeId] = useState([]);
  const [isFirst, setIsFirst] = useState(1);
  const [isAcrFirst, setIsActFirst] = useState(1);
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  //20220831
  const [center, setCenter] = useState([0, 20]);
  const [zoom, setZoom] = useState(1);
  const [content, setContent] = useState("");

  // Mapで表示する数値と色
  const [value, setValue] = useState();
  const [mapColor, setMapColor] = useState("#3ac47d");
  const [mapCategory, setMapCategory] = useState("businesses");

  // 子コンポーネントで色を変更させるための関数
  const changeValueColor = (color) => {
    setMapColor(color);
  };

  // パイチャートをインターバルで変更
  function setSocialMapPieChart(color, category) {
    changeValueColor(color);
    setMapCategory(category);
    setAnimation(true);
    setTimeout(() => setAnimation(false), 1000);
  }
  const colors = ["#555cd8", "#f8b823", "#d92550", "#3ac47d"];
  const labels = ["business_cost", "workers", "beneficiaries", "businesses"];
  const [isInterval, setInInterval] = useState(true);
  let count = 0;
  let interval;
  useEffect(() => {
    if (isInterval) {
      interval = setInterval(() => {
        setSocialMapPieChart(colors[count], labels[count]);

        count += 1;
        if (count > 3) {
          count = 0;
        }
      }, 4400);
      return () => clearInterval(interval);
    } else {
    }
  }, [isInterval]);

  // Markerのアニメーション
  const [animation, setAnimation] = useState(true);

  // 国ごとの活動団体取得用
  const [filterCountry, setFilterCountry] = useState();

  const [filterCountryNeeds, setFilterCountryNeeds] = useState(null);

  // useQuery
  const { loading, error, data, refetch } = useQuery(GET_JOURNY_INFO, {
    variables: {
      sdgs_pk: sdgs_pk,
      sdgs: nodeId,
      project_Activity_Country: filterCountry,
      ...(filterCountryNeeds && {
        csocollaborationneeds_Countries: filterCountryNeeds,
      }),
    },
  });

  useEffect(() => {
    if (isFirst) {
      if (window.location.href.includes("?register")) {
        window.location.href = "/#/dashboards/journy?quetionair";
        window.location.reload();
      }
    } else {
    }
  }, []);

  let showQuestionnaire = false;
  if (window.location.href.includes("?quetionair")) {
    showQuestionnaire = true;
  }

  useEffect(() => {
    if (isFirst) {
    } else {
      refetch({
        sdgs_pk: sdgs_pk,
        sdgs: nodeId,
        project_Activity_Sdgs: nodeId,
      });
    }
  }, [sdgs_pk]);

  useEffect(() => {
    if (isFirst) {
    } else {
      refetch({
        act_pk: act_pk,
        act: nodeId,
        project_Activity_ActivityFields: nodeId,
      });
    }
  }, [act_pk]);

  // ローディング
  const w100 = {
    width: "100%",
    height: "50vh",
  };
  const ma = {
    margin: "auto",
    width: "150px",
    height: "100px",
    height: "100%",
  };
  if (loading)
    return (
      <div>
        <CardHeader className="ema__flex">
          {/* <CardHeader className="card-header-tab"> */}
          <Nav>
            <NavItem>
              <NavLink>活動国</NavLink>
            </NavItem>
            <NavItem>
              <NavLink>SDGs</NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                onClick={() => {
                  sendGAEvent(
                    "pageview",
                    "/#/dashboards/journy/search_by_activity_field_tab"
                  );
                }}
              >
                活動分野
              </NavLink>
            </NavItem>
            <Button className="resetBtn">
              <i className="pe-7s-refresh btn-icon-wrapper resetIcon"> </i>
              リセット
            </Button>
          </Nav>
        </CardHeader>
        <div className="font-icon-wrapper float-left mr-3 mb-3" style={w100}>
          <div
            className="d-flex justify-content-center align-items-center float-center"
            style={ma}
          >
            <img style={{ width: "80px" }} src={animetionLogo}></img>
            {/* <Loader color="#78C3FB" type="ball-grid-pulse" /> */}
          </div>
        </div>
      </div>
    );
  if (error) {
    // alert(error);

    return (
      <div style={{ width: "100%", height: "80vh", display: "flex" }}>
        <spna style={{ margin: "auto" }}>
          制限時間を超過しました、リロードしてください。
          {/* 現在、Amazon Web
          Serviceの障害対応中のためデータが表示できません。ご迷惑お掛けしておりますが今しばらくお待ちください。 */}
        </spna>
      </div>
    );
    // return "制限時間を超過しました、リロードしてください。";
  }
  if (!data) return "...Not Found";

  const { entireValues: val } = data;
  const entireValues = JSON.parse(val);
  const { allActivityfields: activityFields } = data;
  const { allOrgaccount: orgInfo } = data;

  const orgListData = data.allOrgaccount.edges.map((array) => array.node);

  const handleZoomIn = () => {
    setZoom(zoom * 2);
  };

  const handleZoomOut = () => {
    setZoom(zoom / 2);
  };

  const handleCityClick = (city) => {
    setZoom(2);
    setCenter(city.coordinates);
  };

  const handleReset = () => {
    setZoom(1);
    setCenter([0, 20]);
  };

  return (
    <div>
      <Fragment>
        <CSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Card className="mb-3">
            {/* SDGsと活動分野切り替えタブ */}
            <CardHeader className="card-header-tab">
              <Nav>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "0" })}
                    onClick={() => {
                      toggle("0");
                    }}
                  >
                    活動国
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      toggle("1");
                      sendGAEvent("pageview", "/#/dashboards/journy/sdgs_tab");
                    }}
                  >
                    SDGs
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => {
                      sendGAEvent(
                        "pageview",
                        "/#/dashboards/journy/search_by_activity_field_tab"
                      );
                      toggle("2");
                    }}
                  >
                    活動分野
                  </NavLink>
                </NavItem>
                <Button
                  onClick={(e) => {
                    window.location.reload();
                  }}
                  className="resetBtn"
                >
                  <i className="pe-7s-refresh btn-icon-wrapper resetIcon"> </i>
                  リセット
                </Button>
              </Nav>
            </CardHeader>
            <TabContent activeTab={activeTab} className="card-tab-inner">
              <TabPane tabId="0">
                <Row>
                  {/* SDGsボタン */}
                  <Col sm="12">
                    {/* 20220831 地図の拡大・縮小・戻る start */}
                    <Motion
                      defaultStyle={{
                        zoom: 1,
                        x: 0,
                        y: 20,
                      }}
                      style={{
                        zoom: spring(zoom, { stiffness: 210, damping: 20 }),
                        x: spring(center[0], { stiffness: 210, damping: 20 }),
                        y: spring(center[0], { stiffness: 210, damping: 20 }),
                      }}
                    >
                      {({ zoom, x, y }) => (
                        <ComposableMap
                          projectionConfig={{ scale: 205 }}
                          width={820}
                          height={430}
                          style={{
                            width: "100%",
                            height: "auto",
                            marginTop: "10",
                          }}
                        >
                          <ZoomableGroup center={[x, y]} zoom={zoom}>
                            {/* ソーシャルマップ */}
                            <ActiveCountry
                              data={data}
                              value={value}
                              valueColor={mapColor}
                              category={mapCategory}
                              animation={animation}
                              setFilterCountry={setFilterCountryNeeds}
                              setTooltipContent={setContent}
                            />
                          </ZoomableGroup>
                        </ComposableMap>
                      )}
                    </Motion>
                    {/* 20220831 地図の拡大・縮小・戻る end */}
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="1">
                <Row>
                  {/* SDGsボタン */}
                  <Col sm="12">
                    <div className="mb-2">
                      {data.allSdgs &&
                        data.allSdgs.edges &&
                        data.allSdgs.edges.map((sdgsets) => {
                          if (sdgs_pk.includes(sdgsets.node.pk)) {
                            return (
                              <div
                                key={sdgsets.node.id}
                                onClick={() => {
                                  setAnimation(true);
                                  setTimeout(() => setAnimation(false), 1000);
                                  if (isFirst) {
                                    setSdgsPk([sdgsets.node.pk]);
                                    setNodeId([sdgsets.node.id]);
                                    setIsFirst(0);
                                  } else if (sdgs_pk.length > 1) {
                                    setSdgsPk(
                                      sdgs_pk.filter(
                                        (item) => item !== sdgsets.node.pk
                                      )
                                    );
                                    setNodeId(
                                      nodeId.filter(
                                        (item) => item !== sdgsets.node.id
                                      )
                                    );
                                  } else {
                                    console.log("not change");
                                  }
                                }}
                                className="mr-1 pointer"
                                style={{
                                  padding: "none",
                                  background: sdgsets.node.color,
                                  border: "none",
                                  color: "#fff",
                                  marginBottom: 3,
                                  display: "inline-block",
                                }}
                              >
                                {/* {sdgsets.node.title} */}
                                <img
                                  src={sdgsets.node.logoUrl}
                                  alt=""
                                  className="profile-blur opacity-9 map_sdgs_icon"
                                />
                              </div>
                            );
                          } else {
                            return (
                              <div
                                key={sdgsets.node.id}
                                onClick={() => {
                                  setSdgsPk([...sdgs_pk, sdgsets.node.pk]);
                                  setNodeId([...nodeId, sdgsets.node.id]);
                                }}
                                className="mr-1 pointer"
                                style={{
                                  padding: "none",
                                  opacity: 0.2,
                                  border: "none",
                                  color: "#fff",
                                  marginBottom: 3,
                                  display: "inline-block",
                                }}
                              >
                                {/* {sdgsets.node.title} */}
                                <img
                                  src={sdgsets.node.logoUrl}
                                  alt=""
                                  className="profile-blur opacity-9 map_sdgs_icon"
                                />
                              </div>
                            );
                          }
                        })}
                    </div>

                    {/* 20220831 地図の拡大・縮小・戻る start */}
                    <Motion
                      defaultStyle={{
                        zoom: 1,
                        x: 0,
                        y: 20,
                      }}
                      style={{
                        zoom: spring(zoom, { stiffness: 210, damping: 20 }),
                        x: spring(center[0], { stiffness: 210, damping: 20 }),
                        y: spring(center[0], { stiffness: 210, damping: 20 }),
                      }}
                    >
                      {({ zoom, x, y }) => (
                        <ComposableMap
                          projectionConfig={{ scale: 205 }}
                          width={820}
                          height={430}
                          style={{
                            width: "100%",
                            height: "auto",
                            marginTop: "10",
                          }}
                        >
                          <ZoomableGroup center={[x, y]} zoom={zoom}>
                            {/* ソーシャルマップ */}
                            <SdgsMap
                              data={data}
                              value={value}
                              valueColor={mapColor}
                              category={mapCategory}
                              animation={animation}
                              setFilterCountry={setFilterCountry}
                            />
                          </ZoomableGroup>
                        </ComposableMap>
                      )}
                    </Motion>
                    {/* 20220831 地図の拡大・縮小・戻る end */}
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="2">
                <Row>
                  <Col sm="12">
                    <div className="mb-2">
                      {activityFields.edges &&
                        activityFields.edges.map((obj) => {
                          if (act_pk.includes(obj.node.pk)) {
                            return (
                              <Button
                                key={obj.node.id}
                                onClick={() => {
                                  if (isAcrFirst) {
                                    setActPk([obj.node.pk]);
                                    setNodeId([obj.node.id]);
                                    setIsFirst(0);
                                  } else if (act_pk.length > 1) {
                                    setActPk(
                                      act_pk.filter(
                                        (item) => item !== obj.node.pk
                                      )
                                    );
                                    setNodeId(
                                      nodeId.filter(
                                        (item) => item !== obj.node.id
                                      )
                                    );
                                  } else {
                                    console.log("not change");
                                  }
                                }}
                                className="mr-1"
                                style={{
                                  background: obj.node.color,
                                  border: "none",
                                  color: "#fff",
                                  marginBottom: 3,
                                }}
                              >
                                {obj.node.name}
                              </Button>
                            );
                          } else {
                            return (
                              <Button
                                key={obj.node.id}
                                onClick={() => {
                                  setActPk([...act_pk, obj.node.pk]);
                                  setNodeId([...nodeId, obj.node.id]);
                                }}
                                className="mr-1"
                                style={{
                                  background: "#b9b9b9",
                                  border: "none",
                                  color: "#fff",
                                  marginBottom: 3,
                                }}
                              >
                                {obj.node.name}
                              </Button>
                            );
                          }
                        })}
                    </div>

                    {/* 20220831 地図の拡大・縮小・戻る start */}
                    <Motion
                      defaultStyle={{
                        zoom: 1,
                        x: 0,
                        y: 20,
                      }}
                      style={{
                        zoom: spring(zoom, { stiffness: 210, damping: 20 }),
                        x: spring(center[0], { stiffness: 210, damping: 20 }),
                        y: spring(center[0], { stiffness: 210, damping: 20 }),
                      }}
                    >
                      {({ zoom, x, y }) => (
                        <ComposableMap
                          projectionConfig={{ scale: 205 }}
                          width={820}
                          height={430}
                          style={{
                            width: "100%",
                            height: "auto",
                          }}
                        >
                          <ZoomableGroup center={[x, y]} zoom={zoom}>
                            <SdgsMap
                              data={data}
                              value={value}
                              valueColor={mapColor}
                              category={mapCategory}
                              animation={animation}
                              setFilterCountry={setFilterCountry}
                            />
                          </ZoomableGroup>
                        </ComposableMap>
                      )}
                    </Motion>
                    {/* 20220831 地図の拡大・縮小・戻る end */}
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
            {/* 20220831 地図の拡大・縮小・戻る start */}
            <div className="text-center mb-4 mt-2">
              <Button color="primary" className="mr-1" onClick={handleZoomIn}>
                {"Zoom in"}
              </Button>
              <Button color="primary" className="mr-2" onClick={handleZoomOut}>
                {"Zoom out"}
              </Button>
              <Button color="secondary" onClick={handleReset}>
                {"Reset"}
              </Button>
            </div>
            {/* 20220831 地図の拡大・縮小・戻る end */}
          </Card>
          {/* プロジェクト数、投入リソース数、人数、受益者数合計表示コンポーネント */}
          <GraphCards
            obj={entireValues}
            changeColor={changeValueColor}
            changeMapCategory={setMapCategory}
            setAnimation={setAnimation}
            setIsInterval={setInInterval && setInInterval}
          />
          <InfoTable
            as={nodeId}
            orgListData={orgListData}
            title="組織リスト"
            hideButtonCsv={true}
          />
        </CSSTransitionGroup>
        <Tooltip id="my-tooltip" />
        {/* 興味・関心アンケート（サインアップ後のみ） */}
        {/* {showQuestionnaire && <InterestQuestionnaire />} */}
      </Fragment>
    </div>
  );
};

export default JournyDashboard;
